import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { PageLoading } from '@tripian/react';
import ICombinedState from '../../redux/model/ICombinedState';
import { changeTripListVisible } from '../../redux/action/layout';
import MapLayout from './layouts/Map/MapLayout';
import Menu from './layouts/Menu/Menu';
import PlanContainer from './layouts/Container/PlanContiner/PlanContainer';
import FocusContainer from './layouts/Container/FocusContainer/FocusContainer';
import SearchContainer from './layouts/Container/SearchContainer/SearchContainer';
import FavoritesContainer from './layouts/Container/FavoritesContainer/FavoritesContainer';
import usePlan from '../../hooks/usePlan';
import useAlternative from '../../hooks/useAlternative';
import usePoiCategory from '../../hooks/usePoiCategory';
import useFocus from '../../hooks/useFocus';
import useLayoutPlan from './hooks/useLayoutPlan';
import AppNav from '../../App/AppNav/AppNav';
import TripAppMenu from '../../App/AppNav/TripMenu/TripAppMenu';
import TestComponent from '../../tests/TestComponent/TestComponent';
import useTripTest from '../../hooks/useTripTest';
import './TripPlan.scss';

const mapClasses = ['map-container'];
const TripPlanPage = () => {
  const { showPlanList, tripStateForTest } = useSelector((state: ICombinedState) => ({ showPlanList: state.layout.tripListVisible, tripStateForTest: state.trip }));

  const { tripReference, tripFetchTest, loadingTripReference } = useTripTest();
  const { plans, planFetch, loadingPlan, loadingPlans } = usePlan();
  const { alternatives, alternativesFetch } = useAlternative();
  const { poiCategories } = usePoiCategory();
  const { focusLost } = useFocus();

  const { explorePlacesVisible, favoritesVisible, setExplorePlacesVisible, setFavoritesVisible, setYourBookingsVisible, setLocalExperiencesVisible } = useLayoutPlan();

  const dispatch = useDispatch();

  const { hash } = useParams<{ hash: string }>();
  document.title = 'TEST TRIP'; // `${TRIP_PLAN.TITLE} - ${tripReference?.city.name || ''} - ${hash}`;

  // Trip Day Index
  const [day, changeDay] = useState(0);
  // Alternative step Id
  const [alternativesStepId, setAlternativesStepId] = useState<number | undefined>(undefined);

  // Clear
  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      focusLost();
      // dispatch(changeFavoritesVisible(false));
      // dispatch(changeSearchVisible(false));
    };
  }, [dispatch, focusLost]);

  // Trip References
  useEffect(() => {
    if (tripReference === undefined) {
      tripFetchTest(hash, day);
    } else if (tripReference.trip_hash !== hash) {
      // eslint-disable-next-line no-console
      console.warn('TripPlan tripReference.trih_hash and url hash diffirent!');
      // TODO
      // tripFetch(hash, day);
    }
  }, [day, hash, tripFetchTest, tripReference]);

  // Trip Plans
  useEffect(() => {
    if (plans && plans[day].generated_status === 0) {
      planFetch(plans[day].id);
    }
    setAlternativesStepId(undefined);
  }, [day, planFetch, plans]);

  // Alternatives
  useEffect(() => {
    if (plans) {
      alternativesFetch(day);
    }
  }, [alternativesFetch, day, plans]);

  // Alternative Step Id
  useEffect(() => {
    setAlternativesStepId(undefined);
  }, [day]);

  // GoogleMaps clear last route rendered bounds
  useEffect(() => {
    window.twindow.cityBounds = undefined;
    window.twindow.planBounds = undefined;
  }, []);
  /* */
  /* ******* USE EFFECTS ******* */
  /* */
  /* */

  /* */
  /* */
  /* ******* RENDER ******* */
  /* */
  if (!showPlanList) mapClasses.push('w-m-100');

  return (
    <>
      <AppNav
        tripInfoHeader
        tripAppMenu={
          <TripAppMenu
            onClickBookings={() => {
              setYourBookingsVisible(true);
            }}
            onClickFavorites={() => {
              focusLost();
              setFavoritesVisible(true);
            }}
          />
        }
      />

      {loadingTripReference || loadingPlans || loadingPlan ? <PageLoading /> : null}

      <MapLayout planDayIndex={day} fullWidth={!showPlanList} alternativesStepId={alternativesStepId} poiCategories={poiCategories} />
      <TestComponent tripState={tripStateForTest} />

      <PlanContainer
        planDayIndex={day}
        changePlanDayIndex={changeDay}
        show={showPlanList}
        alternativesStepId={alternativesStepId}
        setAlternativesStepId={setAlternativesStepId}
        showExplorePlaces={() => {
          setExplorePlacesVisible(true);
        }}
        showLocalExperiences={() => {
          setLocalExperiencesVisible(true);
        }}
      />

      {tripReference && plans ? <SearchContainer show={explorePlacesVisible} close={() => setExplorePlacesVisible(false)} poiCategories={poiCategories} dayIndex={day} plans={plans} alternatives={alternatives || []} /> : null}

      <FavoritesContainer
        show={favoritesVisible}
        close={() => {
          setFavoritesVisible(false);
        }}
        dayIndex={day}
      />

      {plans ? <FocusContainer planId={plans[day].id} showTourInfoModal={() => {}} /> : null}

      <Menu
        listShown={showPlanList}
        showList={() => {
          dispatch(changeTripListVisible(!showPlanList));
        }}
        showExplorePlaces={() => {
          setExplorePlacesVisible(true);
        }}
        showFavorites={() => {
          focusLost();
          setFavoritesVisible(true);
        }}
        showBookings={() => setYourBookingsVisible(true)}
        showLocalExperiences={() => setLocalExperiencesVisible(true)}
      />
    </>
  );
};

export default TripPlanPage;
